import clsx from 'clsx';
import type { HTMLAttributes, PropsWithChildren, ReactNode } from 'react';

import {
  authActionBack,
  authActionButtons,
  authActionProgress,
  authActionStack,
} from './share.css';

export const AuthActionStack = ({
  back,
  progress,
  children,
  className,
  ...props
}: PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & {
    back?: ReactNode;
    progress?: ReactNode;
  }
>) => {
  return (
    <div
      className={clsx(authActionStack, className)}
      data-testid="auth-action-stack"
      {...props}
    >
      {back ? <div className={authActionBack}>{back}</div> : null}
      <div className={authActionButtons}>{children}</div>
      {progress ? (
        <div className={authActionProgress} data-testid="auth-progress-slot">
          {progress}
        </div>
      ) : null}
    </div>
  );
};
